import { render, staticRenderFns } from "./marketplaceDetail.vue?vue&type=template&id=d99e236a&scoped=true&"
import script from "./marketplaceDetail.vue?vue&type=script&lang=js&"
export * from "./marketplaceDetail.vue?vue&type=script&lang=js&"
import style0 from "./marketplaceDetail.vue?vue&type=style&index=0&id=d99e236a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99e236a",
  null
  
)

export default component.exports